var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCopyV216Light(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25098 2.5C7.18498 2.5 6.26119 3.111 5.80469 4H18.751C19.4405 4 20.001 4.5605 20.001 5.25V18.1963C20.89 17.7403 21.501 16.816 21.501 15.75V5.25C21.501 3.734 20.267 2.5 18.751 2.5H8.25098Z",
    fill: "#F2AE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.5C3.734 5.5 2.5 6.734 2.5 8.25V18.75C2.5 20.266 3.734 21.5 5.25 21.5H15.75C17.266 21.5 18.5 20.266 18.5 18.75V8.25C18.5 6.734 17.266 5.5 15.75 5.5H5.25Z",
    fill: "#02B37F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopyV216Light);
export default __webpack_public_path__ + "static/media/ic_copy_v2_16_light.fece372aad2670a406d6f208d73fb2e8.svg";
export { ForwardRef as ReactComponent };